export const QR_CODE_SIZE = 160;
export const QR_BACKGROUND_COLOR = "#fff";
export const QR_FOREGROUND_COLOR = "#2E3436";
